var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64403 13.3822C11.6967 13.3822 14.1713 10.9076 14.1713 7.85497C14.1713 4.80234 11.6967 2.3277 8.64403 2.3277C5.59141 2.3277 3.11676 4.80234 3.11676 7.85497C3.11676 10.9076 5.59141 13.3822 8.64403 13.3822ZM8.64403 14.5459C12.3393 14.5459 15.3349 11.5503 15.3349 7.85497C15.3349 4.15968 12.3393 1.16406 8.64403 1.16406C4.94875 1.16406 1.95312 4.15968 1.95312 7.85497C1.95312 11.5503 4.94875 14.5459 8.64403 14.5459Z",
    fill: "#557FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50369 10.7666C8.36464 10.7798 8.2259 10.7382 8.11717 10.6505C8.00844 10.5628 7.93834 10.436 7.92188 10.2973V7.16307C7.93834 7.02435 8.00844 6.89759 8.11717 6.8099C8.2259 6.72221 8.36464 6.68055 8.50369 6.69383C8.64275 6.68055 8.78148 6.72221 8.89021 6.8099C8.99895 6.89759 9.06904 7.02435 9.08551 7.16307V10.2973C9.06904 10.436 8.99895 10.5628 8.89021 10.6505C8.78148 10.7382 8.64275 10.7798 8.50369 10.7666Z",
    fill: "#557FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50071 4.65625C8.35687 4.65625 8.21626 4.6989 8.09666 4.77882C7.97706 4.85873 7.88384 4.97232 7.8288 5.10521C7.77375 5.2381 7.75935 5.38433 7.78741 5.52541C7.81547 5.66648 7.88474 5.79607 7.98645 5.89778C8.08816 5.99949 8.21775 6.06876 8.35883 6.09682C8.4999 6.12488 8.64613 6.11048 8.77903 6.05544C8.91192 6.00039 9.0255 5.90717 9.10542 5.78757C9.18533 5.66797 9.22798 5.52736 9.22798 5.38352C9.22798 5.19064 9.15136 5.00565 9.01497 4.86926C8.87858 4.73287 8.6936 4.65625 8.50071 4.65625",
    fill: "#557FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueInfoIcon);
export default __webpack_public_path__ + "static/media/blueInfoIcon.749c9565ff236cfddb0d373b68edfbc7.svg";
export { ForwardRef as ReactComponent };